import React, { createContext, useState } from "react";

export const InspectionWarrantyContext = createContext({});

const InspectionWarrantyProvider = ({ children }) => {
    const [kojiCD, setKojiCD] = useState({});
    const [ins3MTformData, setIns3MTformData] = useState(false);
    const [ins6MTformData, setIns6MTformData] = useState(false);
    const [ins12MTformData, setIns12MTformData] = useState(false);
    const [ins24MTformData, setIns24MTformData] = useState(false);
    const [ins4YTformData, setIns4YTformData] = useState(false);
    const [ins7YTformData, setIns7YTformData] = useState(false);
    const [ins10YTformData, setIns10YTformData] = useState(false);

    return (
        <InspectionWarrantyContext.Provider
            value={{
                kojiCD, setKojiCD, ins3MTformData, setIns3MTformData, ins6MTformData, setIns6MTformData, ins12MTformData, setIns12MTformData, ins24MTformData, setIns24MTformData, ins4YTformData, setIns4YTformData, ins7YTformData, setIns7YTformData, ins10YTformData, setIns10YTformData
            }}>
            {children}
        </InspectionWarrantyContext.Provider>
    );
};

export default InspectionWarrantyProvider;